import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTorbrowserComponent } from './simple-icons-torbrowser.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTorbrowserComponent ],
    exports:      [ SimpleIconsTorbrowserComponent ],
    bootstrap:    []
})
export class SimpleIconsTorbrowserModule {}
